import { render } from "./InstrumentQueueDashboard.vue?vue&type=template&id=c71b9402&scoped=true"
import script from "./InstrumentQueueDashboard.vue?vue&type=script&lang=js"
export * from "./InstrumentQueueDashboard.vue?vue&type=script&lang=js"

import "./InstrumentQueueDashboard.vue?vue&type=style&index=0&id=c71b9402&lang=scss&scoped=true"
import "./InstrumentQueueDashboard.vue?vue&type=style&index=1&id=c71b9402&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71b9402"],['__file',"src/components/instrumentQueue/InstrumentQueueDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c71b9402"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c71b9402', __exports__)) {
    console.log('reload')
    api.reload('c71b9402', __exports__)
  }
  
  module.hot.accept("./InstrumentQueueDashboard.vue?vue&type=template&id=c71b9402&scoped=true", () => {
    console.log('re-render')
    api.rerender('c71b9402', render)
  })

}


export default __exports__